require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-luigi-colombi.json") })
        }
      }, "path---interviste-luigi-colombi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-luigi-colombi!./.cache/json/interviste-luigi-colombi.json
// module id = 678
// module chunks = 231608221292675